import { render, staticRenderFns } from "./communication-channel-sessions.vue?vue&type=template&id=1c390d60"
import script from "./communication-channel-sessions.vue?vue&type=script&lang=js"
export * from "./communication-channel-sessions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports